import React, { useState, useEffect } from 'react';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import SelectOrganization from '../../common/SelectOrganization';
import { getUsers } from '../../../redux/slices/user';
import type { GetUsersParams } from '../../../types/user';
import type { OrganizationType } from '../../../types/organization';

const SelectUserOrganization = (): React.ReactElement => {
  const dispatch = useDispatch();
  const [selectedOrganization, setSelectedOrganization] = useState<OrganizationType | null>(null);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 組織が選ばれたらユーザの絞り込み検索を行う
  useEffect(() => {
    const params: GetUsersParams = selectedOrganization ? { organizationId: selectedOrganization.id } : {};
    dispatch(getUsers(params));
  }, [selectedOrganization]);

  // EVENT HANDLER
  // ================================================================================

  // プルダウンから組織を選んだとき
  const handleOrganizationChange = (org: OrganizationType | null): void => {
    setSelectedOrganization(org);
  };

  // VIEW
  // ================================================================================

  return <SelectOrganization isClearable={true} selected={selectedOrganization} onChange={handleOrganizationChange} />;
};

export default SelectUserOrganization;
